import { withLazy } from 'app/hocs/withLazy'

export const SmsIcon = withLazy(() => import('common/components/SmsIcon/SmsIcon'))
